export * as sys from './sys'
export { default as dict } from './dict'
export * as order from './order'
export * as goods from './goods'
export * as onlinecs from './onlinecs'
export * as message from './message'
export { default as user } from './customer'
export * as task from './task'
export * as knowledge from './knowledge'
export * as goodsknowledge from './goodsknowledge'
export * as interactive from './interactive'
export * as call from './call'
export * as script from './script'
export * as scene from './scene'
export * as log from './log'
export * as goodsKnowledge from './goods-knowledge'
export * as sizeKnowledge from './sizeKnowledge'
export * as knowledgedata from './knowledgedata'
export * as highFrequency from './highFrequency'
export * as llmCheck from './llmCheck'


/**
 * 处理url, 主要用于redux typePrefix
 * @param url
 * @returns {string}
 */
export const getTypePrefix = (url) => `${url}`.slice(1).replaceAll('/', '_').toLowerCase()
